/**
 * checkSessionApi.js
 *
 * Provides an API call to check if a user session is active.
 * Used to verify session validity on application load or route changes.
 *
 * Exports:
 * - checkSession: Fetches the current session status.
 */

import { get } from "../shared/apiPatterns";

/**
 * Fetches the current session status.
 *
 * @returns {Promise<Object|null>} The API response JSON, or null on error.
 */
export const checkSession = () => get("/check-session", { skipCache: true });
